export default __webpack_public_path__ + "static/media/jsfiddle.f6f8915e.svg";